var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenlisticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 17.9568C35.5 27.5968 27.6661 35.4137 18 35.4137C8.33388 35.4137 0.5 27.5968 0.5 17.9568C0.5 8.31682 8.33388 0.5 18 0.5C27.6661 0.5 35.5 8.31682 35.5 17.9568Z",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 19.1654C12.811 19.1654 13.3333 18.643 13.3333 17.9987C13.3333 17.3544 12.811 16.832 12.1667 16.832C11.5223 16.832 11 17.3544 11 17.9987C11 18.643 11.5223 19.1654 12.1667 19.1654Z",
    fill: "#83919C",
    stroke: "#83919C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 19.1666C18.6443 19.1666 19.1666 18.6443 19.1666 17.9999C19.1666 17.3556 18.6443 16.8333 17.9999 16.8333C17.3556 16.8333 16.8333 17.3556 16.8333 17.9999C16.8333 18.6443 17.3556 19.1666 17.9999 19.1666Z",
    fill: "#83919C",
    stroke: "#83919C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 19.1654C24.811 19.1654 25.3333 18.643 25.3333 17.9987C25.3333 17.3544 24.811 16.832 24.1667 16.832C23.5223 16.832 23 17.3544 23 17.9987C23 18.643 23.5223 19.1654 24.1667 19.1654Z",
    fill: "#83919C",
    stroke: "#83919C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenlisticon);
export default __webpack_public_path__ + "static/media/openlisticon.f90ad21a.svg";
export { ForwardRef as ReactComponent };